/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Declinedeal_Title2Inputs */

const en_coinvestments_declinedeal_title2 = /** @type {(inputs: Coinvestments_Declinedeal_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decline Opportunity`)
};

/**
* | output |
* | --- |
* | "Decline Opportunity" |
*
* @param {Coinvestments_Declinedeal_Title2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_declinedeal_title2 = /** @type {((inputs?: Coinvestments_Declinedeal_Title2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Declinedeal_Title2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_declinedeal_title2(inputs)
});
export { coinvestments_declinedeal_title2 as "coInvestments_declineDeal_title" }